import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useIFrameResizeOnRouteChange() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    window.parentIFrame?.size();
  }, [pathname, search, hash]);
}
